import { ActionFunction1, createAction } from 'redux-actions';

interface ISetCheckoutTimerAction extends types.redux.settings.ISetLanguageAction {}

export const setCheckoutTimer: ActionFunction1<any, any> = createAction(
	'SET_CHECKOUT_TIMER',
	(action: ISetCheckoutTimerAction) => action
);
export const clearCheckoutTimer: ActionFunction1<any, any> = createAction('CLEAR_CHECKOUT_TIMER');
